/******************************************************************************
 *
 * Copyright (c) 2019-2020 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Vishal Goel’ <vishal@wakencode.com>, February 2020
 *
 *****************************************************************************/

import React, { Component } from "react";
import styles from "./SideDrawer.module.css";
import Card from "../Card/Card";
import { connect } from "react-redux";
import FilterDrawer from "../FilterDrawer/FilterDrawer";
import { Element } from "react-scroll";
import Shimmer from "../../../Shimmer/Shimmer";
import Header from "./../../../Header/Header";
import { toast } from "react-toastify";
import {
  fetchTodaysGeometry,
  fetchFilteredGeometry,
} from "./../../../store/actions";
import { constant } from "./../../../shared/constants/constants";
import cx from "classnames";
import SideDrawerToggler from "./../../../SideDrawerToggler/SideDrawerToggler";
import GeometryCheckbox from "./GeometryCheckbox";
import { getTimestamps } from "../../../shared/utlilty";

const getStatus = (coordinates, equipmentId) => {
  for (let c of coordinates) {
    if (c.equipmentId === equipmentId) {
      return c.lastUpdatedStatus;
    }
  }
  return "unknown";
};

class SideDrawer extends Component {
  constructor(props) {
    super(props);
    // initial checkbox states
    this.state = {
      showInactiveTodaysGeometry: false,
    };
    // store dates for which geometries need to fetch
    this.workOrderDates = [];
  }

  // handle todays geometry check box
  handleTodaysGeometryCheckbox = (event) => {
    // set the check box status in state
    this.setState({ showInactiveTodaysGeometry: event.target.checked });

    toast.info(constant.FETCHING_PROPERTIES, {
      autoClose: 5000,
    });

    // fetch inactive geometry if checkbox is ticked else active properties
    this.props.fetchTodaysGeometry(event.target.checked);
  };

  /**
   *
   * @param {*} startTime user selected time coming from replay coordinates component
   * @param {*} endTime user selected time coming from replay coordinates component
   * @param {*} id selected card property id
   */
  replaySubmitHelper = (startTime, endTime, id) => {
    this.workOrderDates = getTimestamps(startTime, endTime);

    // fetch geometries for each dates
    this.props.fetchFilteredGeometry(this.workOrderDates);

    // fetch replay coordinates
    this.props.replaySubmitHandler(startTime, endTime, id);
  };

  render() {
    return (
      <>
        <SideDrawerToggler
          toggleSideDrawer={this.props.toggleSideDrawer}
          isSideDrawerVisible={this.props.isSideDrawerVisible}
        />
        <div
          className={cx(
            styles.SideDrawer,
            this.props.isSideDrawerVisible ? styles.Open : styles.Close
          )}
          id="scroll-container">
          <Header />

          {!this.props.isVehicleDetailsVisible && (
            <GeometryCheckbox
              handleChange={this.handleTodaysGeometryCheckbox}
              checked={this.state.showInactiveTodaysGeometry}
            />
          )}

          {!this.props.isVehicleDetailsVisible ? (
            <div className={styles.CardCont}>
              {this.props.usersVehiclesInfo.vehicles.length > 0 ? (
                this.props.usersVehiclesInfo.vehicles.map((vehicle) => (
                  <Element name={vehicle.key} key={vehicle.key}>
                    <Card
                      key={vehicle.key}
                      selected={vehicle.key === this.props.selectedVehicle.key}
                      vehicleSelect={this.props.vehicleSelect}
                      info={vehicle}
                      updatedStatus={getStatus(
                        this.props.coordinates,
                        vehicle.id
                      )}
                      showVehicleDetails={this.props.vehicleDetailHandler}
                    />
                  </Element>
                ))
              ) : (
                // <>
                //   <Shimmer />
                //   <Shimmer />
                // </>
                // Write a component for no data found
                <div className={styles.NoDataFound}>
                  <h3>No data found</h3>
                </div>
              )}
            </div>
          ) : (
            <FilterDrawer
              closeVehicleDetailDrawer={this.props.closeVehicleDetailDrawer}
              info={this.props.selectedVehicleHistory}
              pause={this.props.pauseTrack}
              play={this.props.playTrack}
              reset={this.props.resetTrack}
              forward={this.props.forwardTrack}
              backward={this.props.backwardTrack}
              isPaused={this.props.isPausedTrack}
              plotWhole={this.props.plotWholeTrack}
              replaySubmitHelper={this.replaySubmitHelper}
              timestamp={this.props.replayTimeStamp}
              showControls={this.props.showReplayControls}
              initialTimestamp={this.props.initialReplayTimestamp}
              visitsInfo={this.props.visitsInfo}
              resetCheckboxStatus={this.resetCheckboxStatus}
            />
          )}
        </div>
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    fetchTodaysGeometry: (allowInactive) =>
      dispatch(fetchTodaysGeometry(allowInactive)),
    fetchFilteredGeometry: (allowInactive, dates) =>
      dispatch(fetchFilteredGeometry(allowInactive, dates)),
  };
};

const mapStateToProps = (state) => {
  return {
    usersVehiclesInfo: state.vehicle.usersVehiclesInfo,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(SideDrawer);
